export default __webpack_public_path__ + "static/nj-logo-bc95820b63b58243d2b4fa83f6559221.webp";